<template>
  <div v-if="searchKeyword === '' && mfilter === '' && levelLists.length !== 0">
    <!-- levelLists -->
    <div class="mb-4">
      <button
        v-for="(level, index) in levelLists"
        type="button"
        class="btn my-1 p-2"
        :class="filterClass(index, level)"
        @click="updateLevelFilter(level)"
      >
        <span class="filter-font" :class="filterFontClass(level)">{{
          level
        }}</span>
      </button>
      <button
        v-if="isBookandVideo"
        type="button"
        class="btn my-1 p-2"
        :class="filterClass(levelLists.length, '*')"
        @click="updateLevelFilter('*')"
      >
        <span class="filter-font" :class="filterFontClass('*')">Video</span>
      </button>
    </div>
  </div>
</template>
<script>
import { ApiSearchCourseResource } from "../http/apis/CourseDetail";
import { ApiSearchCollectionResource } from "../http/apis/Collection";
export default {
  name: "FilterButtonGroup",
  data(vm) {
    return {
      typeList: [
        { text: vm.$t("all-type"), id: "all" },
        { text: vm.$t("picture-book"), id: "book" },
        { text: vm.$t("video"), id: "video" },
      ],
      selectType: "all",
      searchRname: "",
      selectSortType: "",
      searchStatus: false,
      tempSearchName: "",
      textbookList: [],
      courseid: this.$route.params.courseid,
      colSortList: [],
      setAlllevel: "",
      levelLists: [],
      haveLevel: false,
      courseInfo: {},
      collectionInfo: {},
      topicList: [],
      isBookandVideo: false,
    };
  },
  props: ["mfilter", "page", "selectLevelList", "searchKeyword"],
  methods: {
    //
    updateLevelFilter(level) {
      this.$emit("addselectLevelList", level);
    },
    filterClass(index, level) {
      let temp = "";
      if (index === 0) {
        temp = "rectangle";
      } else if (index === this.levelLists.length) {
        temp += " rectangleend";
      } else {
        temp = " square";
      }
      if (index % 2 === 0) {
        temp += " filter-even-color";
      } else {
        temp += " filter-odd-color";
      }
      if (this.selectLevelList.includes(level) && this.searchKeyword === "") {
        temp += " select-filter-color";
      }
      if (index === this.levelLists.length - 1 && !this.isBookandVideo) {
        temp += " rectangle2 ";
      } else if (index === this.levelLists.length) {
        temp += " rectangle2 ";
      }
      return temp;
    },
    filterFontClass(level) {
      let temp = "";
      if (this.selectLevelList.includes(level) && this.searchKeyword === "") {
        temp += " select-filter-font";
      } else {
        temp += " filter-font";
      }
      return temp;
    },

    //
    clearLevelFilter() {
      this.selectLevelList = [];
    },
    removeLevel(level) {
      let vm = this;
      let index = this.selectLevelList.indexOf(level);

      if (index !== -1) {
        vm.selectLevelList.splice(index, 1);
      }
    },
    async getLevelList() {
      let vm = this;
      if (this.searchRname !== "") {
        this.searchStatus = true;
        this.tempSearchName = this.searchRname;
      } else {
        this.searchStatus = false;
      }
      let sType = this.selectType;
      if (this.selectType === "all") {
        sType = "*";
      }
      let searchObj = {
        type: sType,
        keyword: this.searchRname,
      };
      console.log(searchObj);
      let result = await ApiSearchCourseResource.post(this.courseid, searchObj)
        .then((response) => {
          console.log(response);
          this.topicList = response.video_topics;
          if (vm.selectSortType === "") {
            if (response.csrInfo.cntLevel !== 0) {
              vm.haveLevel = true;
              vm.selectSortType = "level_asc";
            } else {
              vm.haveLevel = false;
              vm.selectSortType = "unit_asc";
            }
          }
          let temp = [];
          response.record.forEach((element) => {
            // console.log(element.note);
            if (
              (element.note === "video" ||
                element.note === "book" ||
                element.note === "mangosteems_book") &&
              !temp.includes(element.note)
            ) {
              temp.push(element.note);
            }
            if (
              element.level !== undefined &&
              element.level !== "" &&
              !vm.levelLists.includes(element.level)
            ) {
              vm.levelLists.push(element.level);
            }
            if (element.unit === undefined) {
              element.unit = "";
            }
            element.link = element.information.includes("http");
          });
          // $compareWords
          this.textbookList = response.record;
          // console.log("levellist = ", this.levelLists);
          this.levelLists.reverse();
          this.levelLists.sort((a, b) => {
            // console.log(a, b);
            if (b === "aa") {
              return 1;
            } else if (a === "aa") {
              return -1;
            }
            return a.toLowerCase() > b.toLowerCase()
              ? 1
              : a.toLowerCase() < b.toLowerCase()
              ? -1
              : 0;
          });

          if (
            (temp.includes("video") && temp.includes("book")) ||
            (temp.includes("video") && temp.includes("mangosteems_book"))
          ) {
            this.isBookandVideo = true;
          }

          if (response.status === "success") {
            return true;
          }
        })
        .catch((err) => {});
      if (result) {
        // console.log("= FilterButton call GetMlist = ");
        // console.log("textbookList = ", this.textbookList);
        this.$emit("getMList", this.sortMList);
        this.$emit("getFilterInfo", this.selectLevelList, this.selectSortType);
        this.$emit("getTopicList", this.topicList);
        return true;
      }
    },
    async searchCollectionResource() {
      let vm = this;
      let type = this.selectType;
      let keyword = this.searchRname;
      if (this.selectType === "all") {
        type = "*";
      }
      if (this.searchRname === "") {
        keyword = "*";
      }
      if (this.searchRname !== "") {
        this.searchStatus = true;
        this.tempSearchName = this.searchRname;
      } else {
        this.searchStatus = false;
      }

      let result = await ApiSearchCollectionResource.get(
        this.userid,
        this.$route.params.cid,
        keyword,
        type
      )
        .then((response) => {
          if (vm.selectSortType === "") {
            if (response.moreInfo.cntLevel !== 0) {
              vm.haveLevel = true;
              vm.selectSortType = "level_asc";
            } else {
              vm.haveLevel = false;
              vm.selectSortType = "unit_asc";
            }
          }
          response.record.forEach((element) => {
            //重建
            if (
              element.level !== undefined &&
              element.level !== "" &&
              !vm.levelLists.includes(element.level)
            ) {
              vm.levelLists.push(element.level);
            }
            element.lastplay = [];
            element.last_access_all.forEach((item) => {
              if (item.last_access !== "0") {
                element.lastplay.push(item);
              }
            });
          });
          this.textbookList = response.record;
          // this.collectionInfo = response.moreInfo;
          if (response.moreInfo.cntLevel === 0) {
            let slist = [
              { text: "Sort by title A to Z", id: "title_asc" },
              { text: "Sort by title Z to A", id: "title_desc" },
              { text: "Sort by unit Smallest to Largest", id: "unit_asc" },
              { text: "Sort by unit Largest to Smallest", id: "unit_desc" },
            ];
            vm.$store.dispatch("common/setSortTypeList", slist);
          } else if (response.moreInfo.cntUnit === 0) {
            let slist = [
              { text: this.$t("sort-by-title-a-to-z"), id: "title_asc" },
              { text: this.$t("sort-by-title-z-to-a"), id: "title_desc" },
              { text: this.$t("sort-by-level-a-to-z"), id: "level_asc" },
              { text: this.$t("sort-by-level-z-to-a"), id: "level_desc" },
            ];
            vm.$store.dispatch("common/setSortTypeList", slist);
          }
          if (response.status === "success") {
            return true;
          }
        })
        .catch((err) => {});
      if (result) {
        this.$emit("getMColList", this.sortMList);
        return true;
      }
    },
    selectAllLevel(event) {
      const vm = this;

      if (!event.currentTarget.checked) {
        vm.selectLevelList = [];
      } else {
        //實現全選
        vm.selectLevelList = [];
        vm.levelLists.forEach(function(level, i) {
          vm.selectLevelList.push(level);
        });
      }
    },
  },
  async created() {
    this.openedTextbookList = this.openedTextbookLists;

    if (this.page !== "collection") {
      this.getLevelList();
    }
    if (this.page === "collection") {
      let temp = await this.searchCollectionResource();
    }

    this.courseInfo = this.courseInfos;
  },
  computed: {
    courseInfos() {
      return this.$store.state.courseInfo.courseInfo;
    },
    userid() {
      return this.$store.state.auth.userid;
    },
    sortMList() {
      let sortMaterial = [];
      let openb = this.textbookList.filter((item) => {
        return item.openflag === "true" && item.note === "book";
      });
      let openv = this.textbookList.filter((item) => {
        return item.openflag === "true" && item.note === "video";
      });
      if (this.mfilter === "openm") {
        // return this.$_sortMaterial(this.openedMList, this.selectSortType);
        sortMaterial = this.$_sortMaterial(
          this.openedMList,
          this.selectSortType,
          this.selectLevelList
        );
      } else if (this.mfilter === "openb") {
        sortMaterial = this.$_sortMaterial(
          openb,
          this.selectSortType,
          this.selectLevelList
        );
        // return this.$_sortMaterial(this.openedBookList, this.selectSortType);
      } else if (this.mfilter === "openv") {
        sortMaterial = this.$_sortMaterial(
          openv,
          this.selectSortType,
          this.selectLevelList
        );
        // return this.$_sortMaterial(this.openedVideoList, this.selectSortType);
      } else {
        sortMaterial = this.$_sortMaterial(
          this.textbookList,
          this.selectSortType,
          this.selectLevelList
        );
      }
      return sortMaterial;
    },
    sortTypeList() {
      return this.$store.state.common.sortTypeList;
    },
    openedMList() {
      return this.textbookList.filter((item) => {
        return item.openflag === "true";
      });
    },
    openedBookList() {
      return this.textbookList.filter((item) => {
        return item.openflag === "true" && item.note === "book";
      });
    },
    openedVideoList() {
      return this.textbookList.filter((item) => {
        return item.openflag === "true" && item.note === "video";
      });
    },

    openedTextbookLists() {
      return this.$store.state.courseInfo.openedTextbookList;
    },
  },
  watch: {
    courseInfo() {
      if (this.$route.name !== "CollectionDetail") {
        if (this.courseInfo.cntLevel === 0) {
          let slist = [
            { text: "Sort by title A to Z", id: "title_asc" },
            { text: "Sort by title Z to A", id: "title_desc" },
            { text: "Sort by unit Smallest to Largest", id: "unit_asc" },
            { text: "Sort by unit Largest to Smallest", id: "unit_desc" },
          ];
          this.$store.dispatch("common/setSortTypeList", slist);
        } else if (this.courseInfo.cntUnit === 0) {
          let slist = [
            { text: this.$t("sort-by-title-a-to-z"), id: "title_asc" },
            { text: this.$t("sort-by-title-z-to-a"), id: "title_desc" },
            { text: this.$t("sort-by-level-a-to-z"), id: "level_asc" },
            { text: this.$t("sort-by-level-z-to-a"), id: "level_desc" },
          ];
          this.$store.dispatch("common/setSortTypeList", slist);
        } else {
          let slist = [
            { text: this.$t("sort-by-title-a-to-z"), id: "title_asc" },
            { text: this.$t("sort-by-title-z-to-a"), id: "title_desc" },
            { text: this.$t("sort-by-level-a-to-z"), id: "level_asc" },
            { text: this.$t("sort-by-level-z-to-a"), id: "level_desc" },
            { text: "Sort by unit Smallest to Largest", id: "unit_asc" },
            { text: "Sort by unit Largest to Smallest", id: "unit_desc" },
          ];
          this.$store.dispatch("common/setSortTypeList", slist);
        }
      }
    },
    courseInfos() {
      this.courseInfo = this.courseInfos;
    },
    levelLists(val) {
      // updateLevelFilter
      if (val.length !== 0) {
        this.$emit("addselectLevelList", val[0]);
      }
      // console.log("watch selectLevelList = ", val);
    },

    selectSortType() {
      if (this.page !== "collection") {
        // this.searchCourseResource();
      } else {
        this.searchCollectionResource();
      }
    },
    openedTextbookLists() {
      this.openedTextbookList = this.openedTextbookLists;
    },
    searchRname() {
      if (this.page !== "collection") {
        // this.searchCourseResource();
      } else {
        this.searchCollectionResource();
      }
    },
    selectType() {
      // console.log(this.page);
      if (this.page !== "collection") {
        // this.searchCourseResource();
      } else {
        this.searchCollectionResource();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.rectangle {
  // position: absolute;
  width: 53px;
  height: 53px;
  // left: 350px;
  // top: 329px;
  border-radius: 16px 0px 0px 16px;
}
.rectangle2 {
  // position: absolute;
  width: 53px;
  height: 53px;
  // left: 350px;
  // top: 329px;
  border-radius: 0px 16px 16px 0px;
}
.rectangleend {
  width: 90px;
  height: 53px;
  // left: 350px;
  // top: 329px;
  border-radius: 0px 16px 16px 0px;
}
.square {
  // position: absolute;
  width: 52px;
  height: 53px;
  left: 403px;
  top: 329px;
}

.select-filter-color {
  background: #32c1db !important;
}
.filter-odd-color {
  background: #c0d0e0;
}
.filter-even-color {
  background: #d8e3ef;
}
.filter-font {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  /* or 119% */

  letter-spacing: 0.32px;

  color: #617182;
}
.select-filter-font {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  /* or 119% */

  letter-spacing: 0.32px;

  color: #ffffff;
}
</style>
